import styles from "./PageDescription.module.scss";
import PropTypes from "prop-types";
import { createMarkup } from "../../../utils/helperServices";

const PageDescription = ({ text, className, id }) => {
  return (
    <div
      className={`${styles["page-description"]} ${className}`}
      id={id}
      dangerouslySetInnerHTML={createMarkup(text)}
      id={id}
    ></div>
  );
};

PageDescription.defaultProps = {
  text: "",
  className: ""
};
PageDescription.propTypes = {
  text: PropTypes.any,
  className: PropTypes.string,
  id: PropTypes.string
};

export default PageDescription;
